playHomeLandingAnimation();

function playHomeLandingAnimation() {
  gsap.registerPlugin(ScrollTrigger);

  // Image block fade ins
  const imageBlocks = document.querySelectorAll(
    ".home-landing-blocks .grid-item"
  );

  function fadeIn(el) {
    gsap.fromTo(
      el,
      { autoAlpha: 0 },
      {
        opacity: 1,
        duration: 1,
        overwrite: "auto",
        ease: "expo",
        autoAlpha: 1,
        yPercent: 50,
        delay: 0.5,
        scrollTrigger: {
          trigger: el,
          scrub: true,
        },
      }
    );
  }

  function hide(el) {
    gsap.set(el, { autoAlpha: 0 });
  }

  // Logo scroll animation
  const animation = gsap.timeline({
    scrollTrigger: {
      start: "top top",
      endTrigger: "#MainContent",
      end: "top center",
      scrub: 1,
    },
  });

  animation.to(".home-landing-logo-outer", {
    opacity: 0,
    duration: 1,
  });

  // Helpers
  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
  }
}
